import React from 'react';
import ReactDOM from 'react-dom';
import ListView from './ListView';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import enGB from 'date-fns/locale/en-GB';
import { registerLocale } from 'react-datepicker';

const nezzoagendaListRoots = document.getElementsByClassName('nezzoagenda_list_root');

registerLocale('de', de);
registerLocale('fr', fr);
registerLocale('it', it);
registerLocale('en', enGB);

[].forEach.call(nezzoagendaListRoots, function(nezzoagendaListRoot) { // to keep IE11 compatibility
    const EXTKEY = 'nezzoagenda';
    const detailViewUrl = nezzoagendaListRoot.getAttribute('data-linktodetailpage');
    const initialLimit = parseInt(nezzoagendaListRoot.getAttribute('data-initiallimit'), 10);

    ReactDOM.render(
        <ListView detailViewUrl={detailViewUrl}
                  initialLimit={initialLimit}
                  EXTKEY={EXTKEY} />,

        nezzoagendaListRoot
    );
});



// WEBPACK FOOTER //
// ./React/src/index.js